webpackJsonp([148075458323972],{

/***/ 483:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby Starter Blog","author":"Kyle Mathews"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/2017-11-14-wod/index.md absPath of file >>> MarkdownRemark","html":"<h2>Tuesday 11/14</h2>\n<p>Three rounds for time:</p>\n<p>25 KB snatches\n18 push-ups</p>\n<p>Use a 50 lbs kettlebell.</p>","frontmatter":{"title":"WOD 11.14.2017","date":"November 14, 2017"}}},"pathContext":{"path":"/wod-2017-11-14/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---wod-2017-11-14-916cab31ef5e01c075bf.js